export const defaultEntity = 'medici';
export const entities = ['assistiti', 'medici', 'operatori', 'erogatori'];
export const labels = {
    assistiti: 'Assistiti',
    medici: 'Medici',
    operatori: 'Operatori',
    erogatori: 'Erogatori',
};